/*****************************************************
Alexander Self
1/12/18
EquipmentHours: Displays hours of use by equipment
*****************************************************/
import React from 'react';
import tractor from '../../img/tractor-icon.png';


const EquipmentHours = ({ equipmentHours, sortBy }) => {
  return (
    <ul className="collection with-header">
      <li className="collection-item avatar">
        <i className="material-icons circle"><img src={tractor} height="40" width="40" alt="Tractor" /></i>
        <span className="card-title grey-text text-darken-4">{"\u00a0"}Equipment Hours</span>
        <a className="secondary-content"><i className="material-icons">grade</i></a>
        <div>
          <input name="dashboard-equipmenthours" type="radio" id="dashboard-operating-equipment" onClick={(e) => sortBy(e.target.id)} />
          <label htmlFor="dashboard-operating-equipment">Sort by Operating Hours</label>
          <input name="dashboard-equipmenthours" type="radio" id="dashboard-garage-equipment" onClick={(e) => sortBy(e.target.id)} />
          <label htmlFor="dashboard-garage-equipment">Sort by Garage Hours</label>
        </div>
        <br />
      </li>
      <div className="leaderBoard">
        {
          equipmentHours.map((e, i) => (
            <li className="collection-item" key={e.equipmentNo}>
              <div className="row">
                <div className="col s10 m10 l10 xl10 leaderInfo">
                  <span className="flow-text dash-readable"><b>{e.equipmentNo}</b></span><br />
                  <hr />
                  <div className="row">
                    <div className="col s6 m6 l6 xl6">
                      <span className="equipmentHours flow-text dash-readable">Operating Hours: <b className="employee-active">{e.operatingHours}</b></span>
                    </div>
                    <div className="col s6 m6 l6 xl6">
                      <span className="equipmentHours flow-text dash-readable">Garage Hours: <b className={`employee-inactive`}>{e.garageHours}</b></span>
                    </div>
                  </div>
                </div>
                <div className="col s2 m2 l2 xl2">
                  <a className="secondary-content"><h5>#{i+1}</h5></a>
                </div>
              </div>
            </li>
          ))
        }
      </div>
    </ul>
  );
}

export default EquipmentHours;



































/* END */



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard_equipmenthours.js